export function validator() {
  return (
    _target: any,
    _propertyKey: string,
    descriptor: PropertyDescriptor
  ) => {
    const originalFunction = descriptor.value

    descriptor.value = function(...args: any[]) {
      ;(this as any).validators.push(() => originalFunction.apply(this, args))
      return this
    }
  }
}
